import React from 'react';
import './Journey.css';

const ROLES = [
  {
    period: '2025 to now',
    role: 'Site Reliability Engineer',
    company: 'SITA · Aviation and border systems',
    status: 'Now',
    current: true,
  },
  {
    period: '2025 to now',
    role: 'CNCF Jordan Chapter Organizer',
    company: 'Cloud Native Computing Foundation',
    status: 'Active',
    current: true,
  },
  {
    period: '2023 to now',
    role: 'Technology Consultant',
    company: 'Social Hive · Cloud and SaaS advisory',
    status: 'Active',
    current: true,
  },
  {
    period: '2023 to 2025',
    role: 'DevOps Engineer',
    company: 'WUDUH · Multi-cloud CI/CD and GitOps',
    status: 'Past',
    current: false,
  },
  {
    period: '2022 to 2023',
    role: 'IT Specialist',
    company: 'TDM Group · Six continent support operations',
    status: 'Past',
    current: false,
  },
  {
    period: '2015 to 2022',
    role: 'IT Operations and Support',
    company: 'Philadelphia Pharma · Umniah · Grand IT',
    status: 'Past',
    current: false,
  },
];

function Journey() {
  return (
    <section id="journey" className="spine-layout">
      <div className="spine-col">
        <span>Journey</span>
      </div>
      <div className="section-inner">
        <div className="sec-head">
          <h2 className="sec-title">The journey</h2>
          <span className="sec-num">01 / 03</span>
        </div>
        <div className="timeline">
          {ROLES.map((item, i) => (
            <div key={i} className="tl-row">
              <div className="tl-period">{item.period}</div>
              <div className="tl-info">
                <div className="tl-role">{item.role}</div>
                <div className="tl-company">{item.company}</div>
              </div>
              <div className={`tl-tag ${item.current ? 'current' : ''}`}>
                {item.status}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Journey;
